__turbopack_context__.v({
  "bottomHalf": "SingleProminentArticleCard-module-scss-module__aEIJzq__bottomHalf",
  "description": "SingleProminentArticleCard-module-scss-module__aEIJzq__description",
  "favoriteButton": "SingleProminentArticleCard-module-scss-module__aEIJzq__favoriteButton",
  "image": "SingleProminentArticleCard-module-scss-module__aEIJzq__image",
  "imageLink": "SingleProminentArticleCard-module-scss-module__aEIJzq__imageLink",
  "imageWrapper": "SingleProminentArticleCard-module-scss-module__aEIJzq__imageWrapper",
  "singleProminentArticleCard": "SingleProminentArticleCard-module-scss-module__aEIJzq__singleProminentArticleCard",
  "tags": "SingleProminentArticleCard-module-scss-module__aEIJzq__tags",
  "title": "SingleProminentArticleCard-module-scss-module__aEIJzq__title",
});
